import { render, staticRenderFns } from "./news7.vue?vue&type=template&id=5d7155a3&scoped=true"
import script from "./news7.vue?vue&type=script&lang=js"
export * from "./news7.vue?vue&type=script&lang=js"
import style0 from "./news7.vue?vue&type=style&index=0&id=5d7155a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7155a3",
  null
  
)

export default component.exports